// Component
export const COMPONENT_WORLD_CUP = 'mundial 2022';
// Actions
export const ACTION_MATCH = 'partidos';
export const ACTION_SCHEDULE = 'calendario';



// WEBPACK FOOTER //
// ./src/mundial/utls/constantsMetrics.ts